import { Check, Minus, X } from "lucide-react";

const CELL = {
  yes: <Check className="mx-auto h-4 w-4 text-signal" />,
  partial: <Minus className="mx-auto h-4 w-4 text-mist" />,
  no: <X className="mx-auto h-4 w-4 text-mist/40" />,
};

const ROWS = [
  { c: "Corpus stays on your device", cloud: "no", rag: "yes", smritium: "yes" },
  { c: "Content-addressed, reproducible citations", cloud: "no", rag: "no", smritium: "yes" },
  { c: "Multi-signal rehydration (semantic · temporal · relational)", cloud: "no", rag: "no", smritium: "yes" },
  { c: "Cite-or-abstain — no hallucinated sources", cloud: "partial", rag: "no", smritium: "yes" },
  { c: "Works fully offline", cloud: "no", rag: "partial", smritium: "yes" },
  { c: "Consent-gated ambient capture", cloud: "no", rag: "no", smritium: "yes" },
  { c: "Egress audit + PII redaction (Membrane)", cloud: "no", rag: "no", smritium: "yes" },
  { c: "Data residency by construction (DPDP / GDPR)", cloud: "no", rag: "partial", smritium: "yes" },
  { c: "Flat / free-core pricing (not metered per token)", cloud: "no", rag: "yes", smritium: "yes" },
];

export const ComparisonTable = () => (
  <div className="overflow-x-auto border border-white/10" data-testid="comparison-table">
    <table className="w-full min-w-[720px] border-collapse text-left">
      <thead>
        <tr className="border-b border-white/10 bg-white/[0.02]">
          <th className="px-5 py-5 font-mono text-xs uppercase tracking-[0.14em] text-mist">Capability</th>
          <th className="w-40 px-4 py-5 text-center font-mono text-xs uppercase tracking-[0.14em] text-mist">Cloud memory</th>
          <th className="w-40 px-4 py-5 text-center font-mono text-xs uppercase tracking-[0.14em] text-mist">Local RAG</th>
          <th className="w-40 border-l border-saffron/30 bg-saffron/[0.06] px-4 py-5 text-center font-mono text-xs uppercase tracking-[0.14em] text-saffron">
            Smritium
          </th>
        </tr>
      </thead>
      <tbody>
        {ROWS.map((r) => (
          <tr key={r.c} className="border-b border-white/[0.06] last:border-0">
            <td className="px-5 py-4 text-sm text-bone/90">{r.c}</td>
            <td className="px-4 py-4">{CELL[r.cloud]}</td>
            <td className="px-4 py-4">{CELL[r.rag]}</td>
            <td className="border-l border-saffron/20 bg-saffron/[0.04] px-4 py-4">{CELL[r.smritium]}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="border-t border-white/10 px-5 py-3 font-mono text-[11px] text-mist">
      <span className="text-signal">✓</span> supported · <span>—</span> partial · <span className="opacity-50">✕</span> not supported.
      Reflects typical cloud memory APIs and local RAG toolkits.
    </div>
  </div>
);
